import "./index.css";
import React from "react";
import { createRoot } from "react-dom/client"; // ← NEW IMPORT
import App from "./App";
import * as serviceWorker from "./serviceWorker";
// import 'semantic-ui-css/semantic.min.css';

const container = document.getElementById("root");
const root = createRoot(container); // ← creates a root

root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
